import {useContext} from 'react';
import {FooterContext} from '../Components';

export const useFooterContext = () => useContext(FooterContext);
